'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackSignupCompleted = exports.trackSignupDone = exports.trackInteractionBeforeUnload = exports.trackEventBeforeUnload = exports.trackInteraction = exports.trackEvent = exports.setPortalExisting = exports.setPortalNew = exports.setUserExisting = exports.setUserNew = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _hubspot = require('hubspot.SafeStorage');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _AnalyticsActionTypes = require('../actionTypes/AnalyticsActionTypes');

var _Analytics = require('../selectors/Analytics');

var _actionWithPayload = require('../utils/actionWithPayload');

var _actionWithPayload2 = _interopRequireDefault(_actionWithPayload);

var _UsageTrackerContainer = require('../tracking/UsageTrackerContainer');

var _UsageTrackerContainer2 = _interopRequireDefault(_UsageTrackerContainer);

var _isApp = require('../utils/isApp');

var _QueryParamsContainer = require('../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _Create = require('../selectors/Create');

var _Logger = require('../lib/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _onboarding = require('../../core/constants/onboarding');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOG = _Logger2.default.getLogger('AnalyticsActions');

var setUserNew = exports.setUserNew = function setUserNew() {
  return (0, _actionWithPayload2.default)(_AnalyticsActionTypes.ANALYTICS_USER_NEW);
};
var setUserExisting = exports.setUserExisting = function setUserExisting() {
  return (0, _actionWithPayload2.default)(_AnalyticsActionTypes.ANALYTICS_USER_EXISTING);
};
var setPortalNew = exports.setPortalNew = function setPortalNew() {
  return (0, _actionWithPayload2.default)(_AnalyticsActionTypes.ANALYTICS_PORTAL_NEW);
};
var setPortalExisting = exports.setPortalExisting = function setPortalExisting() {
  return (0, _actionWithPayload2.default)(_AnalyticsActionTypes.ANALYTICS_PORTAL_EXISTING);
};

var trackEvent = exports.trackEvent = function trackEvent(eventName, properties) {
  _UsageTrackerContainer2.default.track(eventName, properties);
};

var trackInteraction = exports.trackInteraction = function trackInteraction(action) {
  return trackEvent('interaction', { action: action });
};

var trackEventBeforeUnload = exports.trackEventBeforeUnload = function trackEventBeforeUnload(eventName, properties) {
  _UsageTrackerContainer2.default.trackBeforeUnload(eventName, properties);
};

var trackInteractionBeforeUnload = exports.trackInteractionBeforeUnload = function trackInteractionBeforeUnload(action, extraProperties) {
  return trackEventBeforeUnload('interaction', _extends({ action: action }, extraProperties));
};

var trackSignupDone = exports.trackSignupDone = function trackSignupDone() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      newUser = _ref.newUser,
      newPortal = _ref.newPortal;

  return function (dispatch, getState) {
    var state = getState();
    var newUserFromStore = (0, _Analytics.isNewUser)(state);
    var newUserFromParam = _QueryParamsContainer2.default.get('newUser') === 'true';
    var newPortalFromStore = (0, _Analytics.isNewPortal)(state) || !!(0, _Create.didRecentlyCreatePortal)(state);
    var newPortalFromParam = _QueryParamsContainer2.default.get('newPortal') === 'true';
    if (newPortal == null && newPortalFromStore == null && !newPortalFromParam) {
      LOG.warn('Unset newPortal on signupDone');
    }
    if (newUser == null && newUserFromStore == null && !newUserFromParam) {
      LOG.warn('Unset newUser on signupDone');
    }
    var properties = {
      newUser: newUser || newUserFromStore || newUserFromParam || false,
      newPortal: newPortal || newPortalFromStore || newPortalFromParam || false
    };
    // Temporary, added as part of Presignup Demo Tour experiment
    // to track control/variant signups as this experiment won't
    // be exposed through Amplitude.
    trackEventBeforeUnload('signupDone', properties);
    if (_hubspot2.default.getItem(_onboarding.PRESIGNUP_DEMO_TOUR_EXPERIMENT_VERSION)) {
      trackInteractionBeforeUnload('presignup-tour-experiment-signup-complete', _extends({}, properties, {
        // The version will either be control (unable to access Presignup Tour)
        // or variant (able to access Presignup Tour, but did not necessarily
        // use it).
        version: _hubspot2.default.getItem(_onboarding.PRESIGNUP_DEMO_TOUR_EXPERIMENT_VERSION)
      }));
    }
  };
};

var trackSignupCompleted = exports.trackSignupCompleted = function trackSignupCompleted() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      newUser = _ref2.newUser;

  return function (dispatch, getState) {
    var state = getState();
    var newUserFromStore = (0, _Analytics.isNewUser)(state);
    var newUserFromParam = _QueryParamsContainer2.default.get('newUser') === 'true';
    var createInfo = (0, _Create.getCreate)(state);
    var newUserFromCreateResult = createInfo.get('userCreated');
    var newUserVal = newUser || newUserFromStore || newUserFromCreateResult || newUserFromParam || false;

    if (!newUserVal) {
      LOG.warn('Unset newUser on signupCompleted', {
        extra: {
          location: window.location,
          newUser: newUser,
          newUserFromStore: newUserFromStore,
          newUserFromCreateResult: newUserFromCreateResult,
          newUserFromParam: newUserFromParam
        }
      });
    }

    try {
      var pageView = {
        event: 'VirtualPageview',
        virtualPageURL: '/signup/completed/' + (0, _isApp.appName)(),
        virtualPageTitle: (0, _isApp.appName)() + ' Signup Completed'
      };
      if (!window.dataLayer) {
        window.dataLayer = [];
      }
      window.dataLayer.push(pageView);
    } catch (error) {
      LOG.error('Unable to send page view push', {
        extra: { error: error }
      });
    }
    trackEventBeforeUnload('signupCompleted', {
      newUser: newUserVal
    });
    dispatch(trackSignupDone({ newUser: newUserVal }));
  };
};